// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__2qHsW","load6":"Spinner_load6__soH70","round":"Spinner_round__2_V4N"};